import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { QuoteType } from "@/lib/interfaces and Enums/ENUMQuoteType";
import { TradeDirection } from "@/lib/interfaces and Enums/ENUMTradeDirection";
import { statusFromAwarded } from "../../colDefs/colDefsShared";

export function determineCounterparty(
  thisTrade: ExecutionStrategy | undefined,
  isOp: boolean,
  isOutright: boolean,
  directionToReturn: any,
  fullTradeData: ExecutionStrategy,
): "" | string {
  
  if (!thisTrade) {
    return fullTradeData.originatingCounterparty
      ? fullTradeData.originatingCounterparty
      : "";
  }
  // OP: show counterparty same as RP
  if (isOp && thisTrade.originatingCounterparty) {
    return thisTrade.originatingCounterparty;
  }
  if (!isOp) {
    // early return for TWO Way logic - Don't show CP until Awarded on
    if (directionToReturn == QuoteType.TwoWay) {
      if (thisTrade?.status && thisTrade?.status != undefined) {
        const currentStatus = thisTrade?.status as ExecutionStrategyStatus;
        if (!statusFromAwarded.includes(currentStatus)) {
          return "";
        }
      }
    } else if (thisTrade.originatingCounterparty) {
      return thisTrade.originatingCounterparty;
    }
  }
  return "";
}

export function determineDirection(
  params: any,
  thisTrade: ExecutionStrategy | undefined,
  isOp: boolean,
  isOutright: boolean,
): "" | TradeDirection {
  if (!thisTrade) {
    return params.value ? params.value : "";
  }
  if (isOp) {
    if (isOutright && thisTrade && thisTrade.unwind != true) {
      if (params?.data?.blockId) {
        return params?.data?.direction; // Eg orders are already on the block.
      }
      return params?.data?.legs?.[0]?.direction; // OP can use the params.
    }
  } else if (!isOp) {
    if (isOutright) {
      if (thisTrade.legs && thisTrade.legs.length > 0) {
        if (thisTrade.legs[0].direction) {
          return thisTrade.legs[0].direction;
        }
      }
    }
  }
  return params.value ? params.value : "";
}
